<template>
  <table class="table table-striped table-bordered text-center">
    <thead class="table-light">
    <tr>
      <th v-if="environment.user_is_admin" scope="col" width="7%">Editar<br>menú</th>
      <th scope="col" width="5%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="titleHelp">Título<br>&#9432;</span></th>
      <th scope="col" width="15%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="nameHelp">Nombre<br>&#9432;</span></th>
      <th scope="col" width="20%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="descriptionHelp">Descripción<br>&#9432;</span></th>
      <th scope="col" width="7%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="positionHelp">Posición<br>&#9432;</span></th>
      <th scope="col" width="5%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="cssClassHelp">CSS class<br>&#9432;</span></th>
      <th scope="col" width="5%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="activeHelp">Activo<br>&#9432;</span></th>
      <th scope="col" width="5%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="typeHelp">Tipo<br>&#9432;</span></th>
      <th scope="col" width="8%"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="draftHelp">Es borrador<br>&#9432;</span></th>
      <th scope="col" width="7%">Editar<br>elementos</th>
      <th v-if="environment.user_is_admin" scope="col" width="7%">Eliminar<br>menú</th>
    </tr>
    </thead>
    <tbody>
    <menus-table-row
        v-for="menu in menus"
        :menu="menu"
        :key="menu.id"
        :environment="environment"
        @delete_menu="onDeleteMenu"
    />
    </tbody>
  </table>
</template>

<script>
import HelpTexts from '@/utils/HelpTexts.js'
import MenusTableRow from '@/components/Tables/MenusTableRow.vue'

export default {
  name: 'menus-table',
  emits: ['delete_menu'],
  components: {
    'menus-table-row' : MenusTableRow
  },
  props: {
    menus: {
      type: Array,
      default: []
    },
    environment: {
      type: Object,
      default: {}
    }
  },
  computed: {
    nameHelp: function () {
      return HelpTexts.getMenuNameText();
    },
    titleHelp: function () {
      return HelpTexts.getMenuTitleText();
    },
    descriptionHelp: function () {
      return HelpTexts.getMenuDescriptionText();
    },
    positionHelp: function () {
      return HelpTexts.getMenuPositionText();
    },
    cssClassHelp: function () {
      return HelpTexts.getMenuCssClassText();
    },
    typeHelp: function () {
      return HelpTexts.getMenuTypeText();
    },
    draftHelp: function () {
      return HelpTexts.getDraftHelp();
    },
    activeHelp: function () {
      return HelpTexts.getMenuActiveText();
    },
  },
  methods : {
    onDeleteMenu (menuId) {
      this.$emit('delete_menu', menuId);
    }
  },
}
</script>

<style>
.table {
  margin: auto;
  width: 90% !important;
}
</style>
